import FileUploadModal from 'components/molecules/csvUploadModal';
import { API_REPORTS_HIDE_PATIENT_DATA } from 'services/dataService/resources';
import dataService from 'services/dataService';
import { showResult } from 'infrastructure/hooks/utils';
import { useTranslation } from 'react-i18next';

import type { FC } from 'react';

interface Props {
  isOpen: boolean;
  toggle: () => any;
}

const HidePatientDataModal: FC<Props> = ({ isOpen, toggle }) => {
  const { t } = useTranslation();
  const uploadCsvFile = async (file: File) => {
    const formData = new FormData();
    formData.append('file', file);

    const { error, data } = await dataService.uploadFile(
      API_REPORTS_HIDE_PATIENT_DATA,
      formData,
      'POST',
    );

    if (error) {
      return { error };
    }

    if (data) {
      showResult();
      toggle();
    }
    return {};
  };

  return (
    <FileUploadModal
      isOpen={isOpen}
      toggle={toggle}
      title={t('adminTools.hidePatientData')}
      sampleFileUrl="/csvTemplates/hidePatientDataTemplate.csv"
      uploadCsvFile={uploadCsvFile}
    />
  );
};

export default HidePatientDataModal;
